import type { UseControllerProps } from 'react-hook-form'

import React from 'react'
import { useFormContext } from 'react-hook-form'

import {
	FormControl,
	FormField,
	FormItem,
	FormLabel,
} from '@/shared/components/ui/form'
import { Switch } from '@/shared/components/ui/switch'

// ----------------------------------------------------------------------

export default function RHFSwitch({
	name,
	label,
	shouldUnregister,
	defaultValue,
}: UseControllerProps & {
	label?: string
}) {
	const { control } = useFormContext()

	return (
		<FormField
			name={name}
			control={control}
			defaultValue={defaultValue}
			shouldUnregister={shouldUnregister}
			render={({ field }) => (
				<FormItem orientation='horizontal'>
					<FormControl>
						<Switch
							ref={field.ref}
							checked={field.value}
							onCheckedChange={field.onChange}
						/>
					</FormControl>
					<FormLabel className='font-normal'>{label}</FormLabel>
				</FormItem>
			)}
		/>
	)
}
